__turbopack_context__.v({
  "className": "instrument_serif_5ecbd80a-module__6s4A4W__className",
});
